export const EULA_URL =
  "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/";
